/*LIBRARY*/
import { connect } from "react-redux";
import domain_list from "../../Data/domain_list";

/*COMPONENT*/

/*REDUX*/

/*PICTURE*/
import icon_product from "../../Assets/png_jpg/icon_product.png";

/*FUNCTION*/
import dict from "../../Data/dict.json";
import { block_license_with_handler } from "../../App/actions/filter_license";
/*DATA*/

/*CONST*/

const NO_LICENSE = ({ auth, block_license_with_handler }) => {
  const toggle_payment_table = () => {
    block_license_with_handler();
  };

  const language = localStorage?.language || auth.language;

  const { domain } = auth;

  const premium_status = domain_list?.[domain]?.status;

  return (
    <>
      {premium_status === "premium" ? (
        <main className="text_big text_center container background_white">
          Anda tidak diperbolehkan mengakses platform ini.
          <br />
          Harap hubungi admin untuk mengaktifasi akun Anda.
        </main>
      ) : (
        <main className="container_light background_white">
          <img src={icon_product} alt="MAPID PRODUCT" width="100" />
          <h1>{dict?.["Feature could not be loaded"]?.[language]}</h1>
          <p>
            {
              dict?.[
                "You do not have a GEO MAPID license yet. Purchase a license to access this feature."
              ]?.[language]
            }
          </p>
          <br />
          <br />
          <br />
          <button
            className="button background_green"
            onClick={toggle_payment_table}
          >
            {dict?.["View Plans"]?.[language]}
          </button>
        </main>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  block_license_with_handler,
})(NO_LICENSE);
